export default "__VITE_ASSET__CdpBw3Wf__"